<template>
  <div class="payment-summary">
    <v-row align="center" no-gutters class="mt-2 mb-4">
      <v-col id="dados-de-pagamento" cols="auto" class="mr-2">
        Resumo do Pedido
      </v-col>
      <v-col>
        <v-divider color="primary" thickness="1" :opacity="0.7" />
      </v-col>
    </v-row>

    <display-adapter>
      <template #mobile>
        <payment-summary-mobile :sectors="filteredSectors" />
      </template>
      <template #desktop>
        <payment-summary-desktop :sectors="filteredSectors" />
      </template>
    </display-adapter>

    <div v-if="!isZeroValue" class="d-flex justify-end">
      <v-col sm="3" class="px-0 py-sm-0">
        <coupon-input />
      </v-col>
    </div>
  </div>
</template>

<script setup lang="ts">
import DisplayAdapter from "@/components/core/DisplayAdapter.vue";
import PaymentSummaryDesktop from "@/components/payment/details/desktop/PaymentSummary.vue";
import PaymentSummaryMobile from "@/components/payment/details/mobile/PaymentSummary.vue";
import CouponInput from "@/components/Ticket/CouponInput.vue";
import { useCartStore } from "@/stores/cart";
import { useCheckoutStore } from "@/stores/checkout";
import Sector from "@/types/Sector";
import { computed } from "vue";
interface Props {
  sectors: Sector[];
}

const cart = useCartStore();

const checkout = useCheckoutStore();

const props = defineProps<Props>();

const total = computed((): number => cart.totalAmount);

const isZeroValue = computed((): boolean => total.value === 0);

const filteredSectors = computed((): Sector[] => {
  return props.sectors.filter((sector) => {
    return sector.sections.some((section) => {
      return section.tickets.reduce((acc, t) => acc + t.quantidade, 0) > 0;
    });
  });
});

function validate(): Promise<boolean> {
  return Promise.resolve(true);
}

async function submit(): Promise<boolean> {
  await checkout.create();

  return true;
}

async function cancel(): Promise<boolean> {
  cart.coupons.clear();

  // Should cancel the order but keep the reservation open

  return Promise.resolve(true);
}

async function enter(): Promise<boolean> {
  return Promise.resolve(true);
}

defineExpose({
  validate,
  submit,
  cancel,
  enter,
});
</script>
